// Phase C1 — Welcome / profile-completion shell. Intentionally lightweight
// for Session 1: prompts the user with next-step CTAs. Full profile editor
// already lives at /profile — we simply route them there.
import React from 'react';
import { Link } from 'react-router-dom';
import { TennisBall, IdentificationBadge, Trophy, ArrowRight } from '@phosphor-icons/react';
import { useAuth } from '../contexts/AuthContext';
import rippersClubLogo from '../assets/rippers-club-logo.png';

export default function WelcomePage() {
  const { user } = useAuth();
  const name = user?.first_name || user?.full_name?.split(' ')[0] || 'friend';
  return (
    <div className="min-h-screen w-full px-4 py-12 flex flex-col items-center" style={{ backgroundColor: '#013523' }}>
      <img src={rippersClubLogo} alt="Rippers Club" className="h-20 w-auto object-contain drop-shadow-[0_0_40px_rgba(201,169,58,0.35)]" />
      <h1 className="mt-6 font-serif text-white text-3xl sm:text-4xl md:text-5xl text-center tracking-tight" data-testid="welcome-title">
        Welcome to Rippers Club, {name}
      </h1>
      <p className="mt-3 text-[13px] text-white/70 text-center max-w-lg">
        Your mobile number is verified. You&apos;re an active member — ready to play.
      </p>
      <div className="mt-8 w-full max-w-md grid gap-3">
        <Link to="/profile" data-testid="welcome-cta-profile"
              className="flex items-center gap-3 rounded-xl border border-white/15 bg-white/[0.05] hover:bg-white/[0.08] px-4 py-3">
          <IdentificationBadge size={24} weight="duotone" className="text-[#c9a93a]" />
          <div className="flex-1">
            <div className="text-white text-[14px] font-medium">Complete your profile</div>
            <div className="text-[11.5px] text-white/60">Photo · USTA rating · home club · favourite sports</div>
          </div>
          <ArrowRight size={18} weight="bold" className="text-white/50" />
        </Link>
        <Link to="/events" data-testid="welcome-cta-events"
              className="flex items-center gap-3 rounded-xl border border-white/15 bg-white/[0.05] hover:bg-white/[0.08] px-4 py-3">
          <Trophy size={24} weight="duotone" className="text-[#c9a93a]" />
          <div className="flex-1">
            <div className="text-white text-[14px] font-medium">Explore events</div>
            <div className="text-[11.5px] text-white/60">Tournaments, round robins, court movement nights</div>
          </div>
          <ArrowRight size={18} weight="bold" className="text-white/50" />
        </Link>
        <Link to="/" data-testid="welcome-cta-skip"
              className="text-center text-[12.5px] text-white/60 hover:text-white py-2">
          Skip for now — take me to the app <ArrowRight size={12} weight="bold" className="inline align-middle" />
        </Link>
      </div>
      <p className="mt-8 text-[11.5px] text-white/45 text-center max-w-md">
        <TennisBall size={12} weight="fill" className="inline align-middle text-[#c9a93a]" />{' '}
        Ladders are joined explicitly — ask an admin or use the ladder page when you&apos;re ready to challenge.
      </p>
    </div>
  );
}
